module.exports = __webpack_public_path__ + "static/media/skirting.fd9e6cc3.svg";